<template>
  <a-modal
    title="影响用户列表"
    :visible="showTubeView"
    width="80%"
    destroyOnClose
    @ok="closeTubeView"
    @cancel="closeTubeView"
    style="position: absolute; left: 18rem; z-index: 999; top: 3rem"
  >
    <a-button
      type="primary"
      style="margin-bottom: 8px"
      @click="exportHandle()"
      :loading="exportLoading"
    >导出</a-button>
    <a-table
      rowKey="id"
      :data-source="dataList"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
    >
      <a-tag color="blue" slot="waterBigStatus" slot-scope="text">{{ text === 1 ? '用水大户' : '普通用户' }}</a-tag>
      <span slot="createTime" slot-scope="text">{{ moment(text).format("YYYY-MM-DD")}}</span>
      <!-- <span slot="action" slot-scope="text, record">
        <a @click="jumpFather(record)">跳转</a>
      </span>-->
    </a-table>
  </a-modal>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import storage from 'store'
export default {
  data() {
    return {
      columns: [
        {
          title: '片区名称',
          dataIndex: 'zoneName'
        },
        {
          title: '物探点号',
          dataIndex: 'geophysicalPointNumber'
        },
        {
          title: '编号',
          dataIndex: 'appearanceNo'
        },
        {
          title: '状态',
          dataIndex: 'waterStatus'
        },
        {
          title: '用户名称',
          dataIndex: 'userNikeName'
        },
        {
          title: '用户地址',
          dataIndex: 'address'
        },
        {
          title: '电话号码',
          dataIndex: 'telephone'
        },
        // {
        //   title: '手机号',
        //   dataIndex: 'phone',
        // },
        {
          title: '安装时间',
          dataIndex: 'installDate',
          scopedSlots: { customRender: 'createTime' }
        },
        {
          title: '口径',
          dataIndex: 'model'
        },
        {
          title: '表型号',
          dataIndex: 'meterModel'
        },
        {
          title: '水价',
          dataIndex: 'waterPrice'
        },
        {
          title: '用户用水类型',
          dataIndex: 'waterBigStatus',
          scopedSlots: { customRender: 'waterBigStatus' }
        }
      ],
      queryUrl: '/pipe-network/user_water_meters/page/geophysical-point-numbers',
      dataList: [],
      dataListLoading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条记录`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100']
      },
      exportFileName: '影响用户数据.xlsx',
      exportDataUrl:'pipe-network/user_water_meters/export',
      exportLoading:false,

      showTubeView: false,
      id: ''
    }
  },
  methods: {
    moment,
    // 导出
    exportHandle() {
      this.exportLoading = true
      const token = storage.get(ACCESS_TOKEN)
      const params = {
        responseType: 'arraybuffer',
        params: {
          analyzeData:true,
          geophysicalPointNumber: this.id,
          // geophysicalPointNumber: 'JS581',
          page: this.pagination.current,
          limit: this.pagination.pageSize,
        },
        headers: {
          Authorization: token
        }
      }
      const url = `${process.env.VUE_APP_API_BASE_URL}${this.exportDataUrl}`
      axios
        .get(url, params)
        .then(res => {
          
          const blob = new Blob([res.data], { type: 'application/octet-stream;charset=utf-8' })
          const fileName = this.exportFileName || '导出数据.xlsx'
          const eLink = document.createElement('a')
          eLink.download = fileName
          eLink.style.display = 'none'
          eLink.href = URL.createObjectURL(blob)
          document.body.appendChild(eLink)
          eLink.click()
          URL.revokeObjectURL(eLink.href)
          document.body.removeChild(eLink)
          this.$message.success('导出完成')
          this.exportLoading = false
        })
        .catch(() => {
          this.exportLoading = false
        })
    },
    pageChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.getDataList()
    },
    edit(id) {
      this.showTubeView = true
      if (id) {
        this.id = id
        this.getDataList()
      }
    },
    //跳转到对应阀门
    jumpFather(record) {
      this.closeTubeView()
      this.$emit('jumpFather', record)
    },
    //获取数据
    getDataList() {
      this.dataListLoading = true
      let params = {
        geophysicalPointNumber: this.id,
        // geophysicalPointNumber: 'JS581',
        page: this.pagination.current,
        limit: this.pagination.pageSize
      }
      this.$http
        .get(this.queryUrl, {
          params
        })
        .then(({ data }) => {
          
          this.dataListLoading = false
          this.dataList = data.list || []
          this.pagination.total = data.total ? parseInt(data.total) : 0
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    closeTubeView() {
      this.showTubeView = false
    }
  }
}
</script>

<style lang="less" scoped>
</style>
